import styled from 'styled-components';
import { media } from '../../../Utils/mediaQueries';
import { Text } from '../../UI/Text';

export const Card = styled.div`
    width: ${props => (props.size ? '350px' : '250px')};
    height: ${props => (props.size ? '350px' : '250px')};
    margin: 8px;
    border-radius: 10px;
    background-image: ${props => (props.src ? `url(${props.src})` : null)};

    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    position: relative;

    &:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        display: block;
        height: 100%;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.1);
    }

    ${media.tablet`
        width: 320px;
        height: 300px;
    `};
`;

export const Layout = styled.div`
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: ${props => (props.column ? 'column' : null)};
    align-items: ${props => (props.align ? props.align : null)};
    justify-content: ${props => (props.justify ? props.justify : null)};
`;

export const OuterInend = styled.div`
    margin: ${props => (props.margin ? props.margin : '2px 0')};
    width: ${props => (props.width ? props.width : 'auto')};
`;

export const UserContainerInfo = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 4px 8px;
    // width: 265px;
    margin-top: 15px;

    ${media.tablet`
        width: 335px;
    `};
`;

export const CaptureContainer = styled.div`
    width: 220px;

    ${media.tablet`
        width: 290px;
    `};
`;

export const TitleText = styled(Text)`
    font-size: 12px;
    font-weight: 200;
    word-wrap: break-word;
    line-height: 1.3;
    margin-top: 5px;
    max-height: calc(20px * 3);
    overflow: hidden;
    // justify-self: ${props => (props.justifySelf ? props.justifySelf : null)};
`;

export const ActivityText = styled(Text)`
    text-align: ${props => (props.textAlign ? props.textAlign : null)};
    font-weight: ${props => (props.tiny ? 300 : 'bold')};
    opacity: 0.9;
    font-size: ${props => {
        if (props.size) {
            return props.size;
        } else if (props.tiny) {
            return '11px';
        } else {
            return '20px';
        }
    }};
    ${media.phone`
        ${props => {
            if (props.tiny) {
                return `
                    font-size: 14px;
                    font-weight: 300;
                `;
            } else {
                return `
                    font-size: 30px;
                `;
            }
        }};
    `};
`;



// WEBPACK FOOTER //
// ./src/UI/Components/ActivityCard/style.js